var __rspack_ns_object = {}